import type { PatientDatesBlock } from '../../../../services/patientCard';
import { Card, DateField } from '../shared';

interface DatesCardProps {
    dates: PatientDatesBlock | undefined;
}

function DatesCard({ dates }: DatesCardProps) {
    return (
        <Card title="Key Dates">
            <div className="grid grid-cols-2 gap-4">
                <DateField label="Next appointment" value={dates?.nextAppointmentDate ?? null} />
                <DateField label="Submission" value={dates?.submissionDate ?? null} />
                <DateField label="Approval" value={dates?.approvalDate ?? null} />
                <DateField label="Scheduled start" value={dates?.scheduledStartDate ?? null} />
                <DateField label="Photos" value={dates?.photosDate ?? null} />
                <DateField label="Last scan" value={dates?.scansDate ?? null} />
            </div>
        </Card>
    );
}

export { DatesCard };
